import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import MediaPlayer from "@/components/ui/media-player.tsx";
import diaryIntro from "@/assets/audios/writing-diary-exercise.m4a";
import { Button } from "@/components/ui/button.tsx";
import { useAuthStore } from "@/lib/stores/authStore";
import { useEffect, useState } from "react";
import { useDiaryStore } from "@/lib/stores/diaryStore";
import ConfirmationModal from "@/components/ui/confirmation-modal";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/diary-adults/exercise-explanation"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Writing a Diary - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.diary",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { hasEntries, fetchEntries } = useDiaryStore();

  const navigate = useNavigate();

  const { user } = useAuthStore();

  useEffect(() => {
    if (user) {
      fetchEntries().catch(console.error);
    }
  }, [user, fetchEntries]);

  const showArchiveButton = user && hasEntries();

  const handleStartDiary = () => {
    navigate({
      to: "/adults/exercises/diary-adults/diary-template",
    });
  };
  const handleRegisterRedirect = () => {
    navigate({ to: "/auth/register" });
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <>
          <div>
            <Button className="w-full" onClick={handleStartDiary}>
              <FormattedMessage id="diary.explanation.writeDiary" />
            </Button>
          </div>
          {showArchiveButton && (
            <Link
              to={"/adults/exercises/diary-adults/archive"}
              search={{ saved: false }}
            >
              <Button className="w-full" variant="secondary">
                <FormattedMessage id="diary.explanation.myDiaryArchive" />
              </Button>
            </Link>
          )}
        </>
      }
    >
      <div>
        <p className="text-small">
          <FormattedMessage id="diary.explanation.intro1" />
          <br />
          <FormattedMessage id="diary.explanation.intro2" />
        </p>
      </div>

      <MediaPlayer src={diaryIntro} />

      <ConfirmationModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onConfirm={handleRegisterRedirect}
        titleKey="common.auth.title"
        messageKey="common.auth.message"
        confirmButtonTextKey="common.auth.register"
        cancelButtonTextKey="common.cancel"
      />
    </ExerciseLayout>
  );
}
